import React from 'react'
import { Link } from "react-router-dom"
import { useTranslation } from 'react-i18next'
import { PLAYGROUND, SERVICES, ROOT } from "../CONSTANTS";
import "./Navigator.css"
const Navigator = () => {

    const { t } = useTranslation();

    return (
        <div className="navigator">
            <span className="navigator__item"><Link to={SERVICES}>{t('nav_services')}</Link></span> 
            <span className="navigator__item"><Link to={PLAYGROUND}>{t('nav_playground')}</Link> </span>
            {/* change route to about this project component.. */}
            <span className="navigator__item"><Link to={ROOT}>{t('nav_about')}</Link> </span> 
        </div>
    )
}

export default Navigator
